module.exports = __webpack_public_path__ + "static/media/Mark Hayes.f924ef8b.png";